// Tabbladen van Planning: Bord, Tijdlijn en Capaciteit.
import { NavLink } from "react-router";

export function PlanningTabs({ current }: { current: "bord" | "tijdlijn" | "capaciteit" }) {
  const tabs: [string, string, string][] = [["bord", "/planning", "Bord"], ["tijdlijn", "/planning/tijdlijn", "Tijdlijn"], ["capaciteit", "/planning/capaciteit", "Capaciteit"]];
  return (
    <div className="ex-tabs p-tabs" role="tablist">
      {tabs.map(([k, to, label]) => (
        <NavLink key={k} to={to} end role="tab" className="ex-tab" aria-selected={current === k}>{label}</NavLink>
      ))}
    </div>
  );
}
